<script setup lang="ts">
/**
 * This component is only for setting up the conversation that is displayed in the
 * conversation.
 *
 * NOTE: The 'key' for the conversation is very important as it creates a new component
 * every time the conversation id is changed.
 */
const { state: conversationState } = useConversations()
const { onCreateOrOpenLatestConversationIntent } = useAgent()

const conversationId = computed(() => conversationState.value.current)

onMounted(async () => {
  if (!conversationId.value)
    await onCreateOrOpenLatestConversationIntent(false)
})
</script>

<template>
  <panel-agent-conversation
    v-if="conversationId"
    :key="conversationId"
    :conversation-id
  />
</template>
